
    	// init controller
	var controller = new ScrollMagic.Controller();

      	// Reveal Header Text

		new ScrollMagic.Scene({
        triggerElement: "#h1trigger",
        triggerHook: 0.9,
        offset: 0, // move trigger to center of element
        reverse: true 
    })
    .setClassToggle("#header_title", "visible") // add class toggle
    .addIndicators() // add indicators (requires plugin)
    .addTo(controller);

	// Reveal header Subtitle Text

		new ScrollMagic.Scene({
        triggerElement: "#h-subtitle-trigger",
        triggerHook: 0.9,
        offset: 0, // move trigger to center of element
        reverse: true 
    })

    .setClassToggle("#h-subtitle-trigger-reavel", "visible") // add class toggle
    .addIndicators() // add indicators (requires plugin)
    .addTo(controller);


		// build scene

		new ScrollMagic.Scene({
        triggerElement: "#h-p-trigger",
        triggerHook: 0.9,
        offset: 0, // move trigger to center of element
        reverse: true 
    })
    .setClassToggle("#h-p-trigger-reveal", "visible") // add class toggle
    .addIndicators() // add indicators (requires plugin)
    .addTo(controller);



// SVG Line 

	// function pathPrepare ($el) {
	// 	var lineLength = $el[0].getTotalLength();
	// 	$el.css("stroke-dasharray", lineLength);
	// 	$el.css("stroke-dashoffset", lineLength);
	// }

	// var $word = $("path#svg");

	// // prepare SVG
	// pathPrepare($word);

	// // init controller
	// var controller = new ScrollMagic.Controller();

	// // build tween
	// var tween = new TimelineMax()
	// 	.add(TweenMax.to($word, 0.9, {strokeDashoffset: 0, ease:Linear.easeNone})) // draw word for 0.9

	// // build scene
	// var scene = new ScrollMagic.Scene({triggerElement: "#svg-trigger", duration: 200, tweenChanges: true})
	// 				.setTween(tween)
	// 				.addIndicators() // add indicators (requires plugin)
	// 				.addTo(controller);



		// Header Photo One
		new ScrollMagic.Scene({
							triggerElement: "#header-photo-one-trigger",
							triggerHook: 0.9,
							offset: 500, // move trigger to center of element
							reverse: true
						})
						.setClassToggle("#header-photo-one-reveal", "visible") // add class toggle
						.addIndicators() // add indicators (requires plugin)
						.addTo(controller);



		// Header Photo Two
		new ScrollMagic.Scene({
							triggerElement: "#header-photo-two-trigger",
							triggerHook: 0.9,
							offset: 300, // move trigger to center of element
							reverse: true
						})
						.setClassToggle("#header-photo-two-reveal", "visible") // add class toggle
						.addIndicators() // add indicators (requires plugin)
						.addTo(controller);



		// Grew Middle
		new ScrollMagic.Scene({
							triggerElement: "#grew_middle_trigger",
							triggerHook: 0.9,
							offset: 50, // move trigger to center of element
							reverse: true
						})
						.setClassToggle("#grew_middle_reveal", "visible") // add class toggle
						.addIndicators() // add indicators (requires plugin)
						.addTo(controller);



		// Grew Left
		new ScrollMagic.Scene({
							triggerElement: "#grew_left_trigger",
							triggerHook: 0.9,
							offset: 150, // move trigger to center of element
							reverse: true
						})
						.setClassToggle("#grew_left_reveal", "visible") // add class toggle
						.addIndicators() // add indicators (requires plugin)
						.addTo(controller);



		// Grew Right
		new ScrollMagic.Scene({
							triggerElement: "#grew_right_trigger",
							triggerHook: 0.9,
							offset: 100, // move trigger to center of element
							reverse: true
						})
						.setClassToggle("#grew_right_reveal", "visible") // add class toggle
						.addIndicators() // add indicators (requires plugin)
						.addTo(controller);

